import axios from "axios";
import { toast } from "react-toastify";
import { BaseURL } from "../Constants/Constants";

const token = localStorage.getItem("auth-token");

function getAuthHeader() {
  const token = localStorage.getItem("auth-token");
  return { Authorization: `Bearer ${token}` };
}

const AllServices = {
  getReferences: async function (referenceNumber) {
    try {
      const response = await axios.get(
        BaseURL + `/getReferences/${referenceNumber}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response;
    } catch (error) {
      if (error.response?.status >= 400 && error.response?.status <= 500) {
        toast.error(error.response.data.message || "Something went wrong!");
      }
      throw error;
    }
  },

  createCustomer: async function (formDataToSend) {
    // for (let pair of formDataToSend.entries()) {
    //   console.log(pair[0] + ": ", pair[1]);
    // }

    try {
      const response = await axios.post(
        BaseURL + `/addCustomer`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response;
    } catch (error) {
      if (error.response?.status >= 400 && error.response?.status <= 500) {
        toast.error(error.response.data.message || "Something went wrong!");
      }
      throw error;
    }
  },

  // createCustomer: async function (formDataToSend) {
  //   console.log("FormData entries:");
  //   for (let pair of formDataToSend.entries()) {
  //     console.log(pair[0] + ": ", pair[1]);
  //   }

  //   try {
  //     const response = await axios.post(
  //       BaseURL + `/addCustomer`,
  //       formDataToSend,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );
  //     console.log("response >>>>> ", response);

  //     return response;
  //   } catch (error) {
  //     console.log("error ---->>> ", error);
  //   }
  // },

  // Login Admin
  loginAdmin: async function (dataObj) {
    try {
      const response = await axios.post(BaseURL + "/logginAdmin", dataObj, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      return response;
    } catch (error) {
      if (error.response?.status >= 400 && error.response?.status < 500) {
        toast.error(error.response.data.message || "Something went wrong!");
      }
      // throw error;
    }
  },

  // add reference details by admin
  addReferenceDetails: async function (dataObj) {
    try {
      const response = await axios.post(
        BaseURL + "/addReferenceDetails",
        dataObj,
        {
          headers: {
            // Authorization: `Bearer ${token}`,
            ...getAuthHeader(),
          },
        }
      );
      return response;
    } catch (error) {
      if (error.response?.status >= 400 && error.response?.status <= 500) {
        toast.error(error.response.data.message || "Something went wrong!");
      }
      throw error;
    }
  },

  getAllReferenceDetails: async function () {
    const token = localStorage.getItem("auth-token");
    try {
      const response = await axios.get(BaseURL + "/getReferenceDetails", {
        headers: {
          // Authorization: `Bearer ${token}`,
          ...getAuthHeader(),
        },
      });

      return response;
    } catch (error) {
      throw error;
    }
  },
  getConfirmAllReferenceDetails: async function () {
    const token = localStorage.getItem("auth-token");
    try {
      const response = await axios.get(
        BaseURL + "/getConfirmReferenceDetails",
        {
          headers: {
            // Authorization: `Bearer ${token}`,
            ...getAuthHeader(),
          },
        }
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteCustomer: async function (item) {
    try {
      const response = await axios.delete(BaseURL + `/deleteCustomer/${item}`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          ...getAuthHeader(),
        },
      });
      return response;
    } catch (error) {
      if (error.response?.status >= 400 && error.response?.status <= 500) {
        toast.error(error.response.data.message || "Something went wrong!");
      }
      throw error;
    }
  },

  gellAllCustomerDetailsById: async function (bookingRefNum) {
    try {
      const response = await axios.get(
        BaseURL + `/getAllcustomerDetailsById/${bookingRefNum}`,
        {
          headers: {
            // Authorization: `Bearer ${token}`,
            ...getAuthHeader(),
          },
        }
      );
      return response;
    } catch (error) {
      if (error.response?.status >= 400 && error.response?.status < 500) {
        toast.error(error.response.data.message || "Something went wrong!");
      }
      // throw error;
    }
  },

  confirmChecking: async function (refNum) {
    try {
      const response = await axios.post(
        BaseURL + `/confirmCheckin/${refNum}`,
        {},
        {
          headers: {
            // Authorization: `Bearer ${token}`,
            ...getAuthHeader(),
          },
        }
      );
      return response;
    } catch (error) {
      if (error.response?.status >= 400 && error.response?.status < 500) {
        toast.error(error.response.data.message || "Something went wrong!");
      }
      // throw error;
    }
  },

  getExcelSheet: async function (dataObj) {
    try {
      const response = await axios.get(BaseURL + `/getExcel/`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          ...getAuthHeader(),
        },
        params: dataObj,
        responseType: "blob",
      });
      return response.data;
    } catch (error) {
      if (error.response?.status === 500) {
        toast.error(error.response.data.message || "Something went wrong!");
      }
      // throw error;
    }
  },

  getCustomerDetails: async function (dataObj) {
    try {
      const response = await axios.get(BaseURL + `/getCustomerDetails/`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          ...getAuthHeader(),
        },
        params: dataObj,
      });

      return response;
    } catch (error) {
      if (error.response?.status >= 400 && error.response?.status <= 500) {
        toast.error(error.response.data.message || "Something went wrong!!!");
      }
      throw error;
    }
  },

  doneCustomer: async function (item) {
    try {
      const response = await axios.post(
        BaseURL + `/updatedStatus/${item}`,
        {},
        {
          headers: {
            // Authorization: `Bearer ${token}`,
            ...getAuthHeader(),
          },
        }
      );
      return response;
    } catch (error) {
      if (error.response?.status === 500) {
        toast.error(error.response.data.message || "Something went wrong!");
      }
      throw error;
    }
  },

  getOwnDetailsById: async function (bookingRefNum) {
    try {
      const response = await axios.get(
        BaseURL + `/getOwnDetailsById/${bookingRefNum}`,
        {
          headers: {
            // Authorization: `Bearer ${token}`,
            ...getAuthHeader(),
          },
        }
      );
      return response;
    } catch (error) {
      if (error.response?.status >= 400 && error.response?.status <= 500) {
        toast.error(error.response.data.message || "Something went wrong!");
      }
      throw error;
    }
  },

  loginWebPortal: async function (dataObj) {
    try {
      const response = await axios.post(BaseURL + "/logginWebPortal", dataObj, {
        headers: {
          ...getAuthHeader(),
        },
        withCredentials: true,
      });
      return response;
    } catch (error) {
      if (error.response?.status >= 400 && error.response?.status < 500) {
        toast.error(error.response.data.message || "Something went wrong!");
      }
    }
  },

  passdataWebPortal: async function (dataObj) {
    try {
      const response = await axios.post(
        BaseURL + "/passdatawebportal",
        dataObj,
        {
          headers: {
            ...getAuthHeader(),
          },
          withCredentials: true,
        }
      );

      return response;
    } catch (error) {
      if (error.response?.status >= 400 && error.response?.status < 500) {
        toast.error(error.response.data.message || "Something went wrong!");
      }
    }
  },

  getRecipt: async function (dataObj) {
    try {
      const response = await axios.post(BaseURL + "/getrecipt", dataObj, {
        headers: {
          ...getAuthHeader(),
        },
        withCredentials: true,
      });

      return response;
    } catch (error) {
      if (error.response?.status >= 400 && error.response?.status < 500) {
        toast.error(error.response.data.message || "Something went wrong!");
      }
    }
  },
  editBookingReference: async function (refNumber, dataObj) {
    try {
      const response = await axios.post(
        BaseURL + `/editReferenceDetails/${refNumber}`,
        dataObj,
        {
          headers: {
            ...getAuthHeader(),
          },
          withCredentials: true,
        }
      );

      return response;
    } catch (error) {
      if (error.response?.status >= 400 && error.response?.status < 500) {
        toast.error(error.response.data.message || "Something went wrong!");
      }
    }
  },
  saveReciptId: async function (refNumber, dataObj) {
    try {
      const response = await axios.post(
        BaseURL + `/saveReciptId/${refNumber}`,
        dataObj,
        {
          headers: {
            ...getAuthHeader(),
          },
          withCredentials: true,
        }
      );

      return response;
    } catch (error) {
      if (error.response?.status >= 400 && error.response?.status < 500) {
        toast.error(error.response.data.message || "Something went wrong!");
      }
    }
  },

  getAllRecepitDetails: async function (dataObj) {
    try {
      const response = await axios.get(BaseURL + `/getrecepitdetails`, {
        headers: {
          ...getAuthHeader(),
        },
        params: dataObj,
        withCredentials: true,
      });
      return response;
    } catch (error) {
      if (error.response?.status >= 400 && error.response?.status < 500) {
        toast.error(error.response.data.message || "Something went wrong!");
      }
    }
  },

  getOneRecepitDetails: async function (dataObj) {
    try {
      const response = await axios.post(
        BaseURL + `/getOnerecepitdetails`,
        dataObj,
        {
          headers: {
            ...getAuthHeader(),
          },
          withCredentials: true,
        }
      );
      return response;
    } catch (error) {
      if (error.response?.status >= 400 && error.response?.status < 500) {
        toast.error(error.response.data.message || "Something went wrong!");
      }
      throw error;
    }
  },
};

export default AllServices;
